import { render, staticRenderFns } from "./SenderMailAddress.vue?vue&type=template&id=7f97257b&scoped=true"
import script from "./SenderMailAddress.vue?vue&type=script&lang=js"
export * from "./SenderMailAddress.vue?vue&type=script&lang=js"
import style0 from "./SenderMailAddress.vue?vue&type=style&index=0&id=7f97257b&prod&scoped=true&lang=scss"
import style1 from "./SenderMailAddress.vue?vue&type=style&index=1&id=7f97257b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f97257b",
  null
  
)

export default component.exports